import React, { useState } from 'react';
import { Check } from 'lucide-react';
import { Btn } from './bits';
import { useSpeech, MicButton, Listening } from './voice';

// Controlled textarea with a mic; spoken words are appended to what is already typed.
export function SpokenField({ id, label, value, onChange, testId, hint }) {
  const [base, setBase] = useState('');
  const sp = useSpeech((heard) => onChange(`${base}${heard}`));
  const toggleMic = () => { if (!sp.listening) setBase(value ? `${value.trim()} ` : ''); sp.toggle(); };
  return (
    <>
      <label className="fl-label" htmlFor={id}>{label}{hint && sp.supported && <span className="fl-muted" style={{ fontWeight: 500, textTransform: 'none', letterSpacing: 0 }}> · {hint}</span>}</label>
      <div className="fl-note-row">
        <textarea id={id} className="fl-textarea" style={{ margin: 0 }} value={value} placeholder={sp.listening ? 'Listening…' : ''} onChange={(e) => onChange(e.target.value)} data-testid={testId} />
        {sp.supported && <MicButton listening={sp.listening} onClick={toggleMic} label="Speak instead" testId={`${testId}-mic`} />}
      </div>
      {sp.listening && <Listening testId={`${testId}-listening`} />}
      {sp.error && <span className="fl-small fl-cam-msg" data-testid={`${testId}-error`}>{sp.error}</span>}
    </>
  );
}

// Short note captured by typing or speaking; spoken words are appended to what is already typed.
export function VoiceNote({ value, onSave, label, hint, placeholder, testId, compact }) {
  const [text, setText] = useState(value || '');
  const [saved, setSaved] = useState(!!value);
  const [base, setBase] = useState('');
  const sp = useSpeech((heard) => { setText(`${base}${heard}`); setSaved(false); });
  const toggleMic = () => { if (!sp.listening) setBase(text ? `${text.trim()} ` : ''); sp.toggle(); };
  const save = () => { onSave(text.trim()); setSaved(true); };
  return (
    <div className="fl-note" data-testid={testId}>
      {label && <label className="fl-label" htmlFor={`${testId}-text`} style={{ margin: '0 0 6px' }}>{label} {hint && <span className="fl-muted" style={{ fontWeight: 500, textTransform: 'none', letterSpacing: 0 }}>· {hint}</span>}</label>}
      <div className="fl-note-row">
        <textarea id={`${testId}-text`} className="fl-textarea" style={{ minHeight: compact ? 48 : 56, margin: 0 }} value={text} placeholder={sp.listening ? 'Listening…' : placeholder} onChange={(e) => { setText(e.target.value); setSaved(false); }} data-testid={`${testId}-text`} />
        {sp.supported && <MicButton listening={sp.listening} onClick={toggleMic} label="Speak instead" testId={`${testId}-mic`} />}
      </div>
      <div className="fl-row" style={{ alignItems: 'center' }}>
        <Btn primary onClick={save} testId={`${testId}-save`}>{saved ? <><Check size={14} /> Saved</> : 'Save note'}</Btn>
        {sp.listening && <Listening testId={`${testId}-listening`} />}
        {!sp.supported && <span className="fl-small" style={{ margin: 0 }}>Voice capture isn't available in this browser — typing works.</span>}
        {sp.error && <span className="fl-small fl-cam-msg" style={{ margin: 0 }} data-testid={`${testId}-error`}>{sp.error}</span>}
      </div>
    </div>
  );
}
